// extracted by mini-css-extract-plugin
export default {"indicator":"slider--17hs8","indicator--active":"slider--8ytAG"};